import React from 'react';
import { Route, Routes } from 'react-router-dom';

import LandingPage from './screen/landingPage';
import DeleteAccount from './screen/delete-account';
import AnnouncementPage from './screen/announcement';

import '@fontsource/onest';

import './App.scss';
import PrivacyPolicy from './screen/privacy-policy';

const App = () => {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/aviso" element={<AnnouncementPage />} />
      <Route path="/excluir-minha-conta" element={<DeleteAccount />} />
      <Route path="/politica-de-privacidade" element={<PrivacyPolicy />} />
    </Routes>
  );
};

export default App;
